import {Pipe, PipeTransform} from '@angular/core';

export function roundToDecimals(value: number, decimals = 2): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

@Pipe({
  name: 'roundToDecimals',
})
export class RoundToDecimalsPipe implements PipeTransform {
  transform(value: number, decimals = 2): number {
    return roundToDecimals(value, decimals);
  }
}
